import { Typography, styled } from '@mui/material';

export const StyBlackBoldText = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
    color: theme.palette.black,
}));

export const StyPrimaryBoldText = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
    color: theme.palette.primary.main,
}));

export const StyPrimaryText = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
}));

export const StyText = styled(Typography)(({ theme }) => ({
    color: theme.palette.black,
}));
